import styled, { css } from 'styled-components';

export const SelectItem = styled.div<{ $isSelected?: boolean }>`
	border-radius: 5px;
	margin-right: 3px;
	padding: 4px;
	padding-right: 6px;
	padding-left: 6px;
	font-weight: ${props => props.theme.regular};
	cursor: ${props => (props.$isSelected ? 'not-allowed' : 'pointer')};
`;

export const FieldSelect = styled.div<{ $editMode: boolean }>`
	display: flex;
	justify-content: space-evenly;
	height: 100%;
	width: 100%;
	${props => props.$editMode && 'cursor: pointer'};
`;

export const FieldSelectItem = styled.div<{
	$backgroundColor?: string;
	$height: number;
	$color?: string;
	$border?: boolean;
	$borderColor?: string;
	$hasLabel?: boolean;
}>`
	background-color: ${props => props.$backgroundColor};
	${props =>
		props.$color
			? css`
					color: ${props.$color};
				`
			: null}
	height: ${props => `${props.$height}px`};
	line-height: ${props => `${props.$height}px`};
	width: 100%;
	gap: 5px;
	display: flex;
	justify-content: flex-start;
	align-items: center;
	padding-left: ${props => (props.$hasLabel ? '0px' : '5px')};
	white-space: nowrap;
	&,
	div {
		text-overflow: ellipsis;
		overflow: hidden;
	}
	&:hover {
		opacity: 0.9;
	}
`;

export const FieldSelectMenuOption = styled.div<{ $height: number; $selected: boolean; $leftItemWidth?: number; $paddingRight?: number }>`
	display: grid;
	grid-template-columns: ${props => (props.$leftItemWidth ? `${props.$leftItemWidth}px 1fr` : '1fr')};
	align-items: center;
	padding: 0px 20px;
	height: ${props => `${props.$height}px`};
	transition: all 0.5s ease-in-out;
	position: relative;
	cursor: pointer;
	background-color: ${props => (props.$selected ? 'rgba(30, 18, 111, 0.08)' : 'inherit')};
	&:hover {
		opacity: 0.5;
	}
	${props => (props.$paddingRight ? `padding-right: ${props.$paddingRight}px` : '')}
`;
export const FieldSelectMenuOptionLabelWrapper = styled.div`
	text-overflow: ellipsis;
	overflow: hidden;
	white-space: nowrap;
	width: 100%;
`;

export const FieldSelectOptionsWrapper = styled.div<{ $optionCount: number }>`
	display: flex;
	flex-direction: column;
	/* grid-template-columns: ${props => `repeat(${Math.ceil(props.$optionCount / 6)}, 1fr)`}; */
`;

export const LinkMenuOption = styled.div<{ $height: number; $selected: boolean }>`
	display: flex;
	gap: 0.5rem;
	align-items: center;
	height: ${props => `${props.$height}px`};
	transition: all 0.3s ease-in-out;
	cursor: pointer;
	&:hover {
		background-color: ${props => (props.$selected ? 'inherit' : props.theme.palette.swiftfox.neutral['20-offWhite'])};
	}
`;
export const LinkMenuOptionLabelWrapper = styled.div`
	text-overflow: ellipsis;
	overflow: hidden;
	white-space: nowrap;
	width: 100%;
`;

export const LinkMenuOptionWrapper = styled.div<{ $optionCount: number }>`
	display: flex;
	flex-direction: column;
	/* display: grid;
	grid-template-columns: ${props =>
		Math.ceil(props.$optionCount / 6) === 1 ? 'minmax(13rem, 100%)' : `repeat(${Math.ceil(props.$optionCount / 6)}, 13rem)`}; */
	column-gap: 1rem;
`;
